import { useEffect } from 'react';

/** Close a custom, non-MUI dialog when the user presses Escape. */
export default function useEscapeKeyClose({ isEnabled = true, onClose }) {
  useEffect(() => {
    if (!isEnabled || !onClose) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [isEnabled, onClose]);
}
